import { SandboxedTagSwap } from "@pjs/security";
import { BasicTagSwap } from "./BasicTagSwap";

export const italicTransform: SandboxedTagSwap = new BasicTagSwap("I");
